import { getOwnerRpc } from 'growth-monetization-service-types';
import { rpcClient } from '../client';
export const fetchOwners = () => rpcClient.call(getOwnerRpc, {});